import React from "react";
import styles from "./LoanSummary.module.scss";
import { IoIosArrowBack } from "react-icons/io";
import { Link } from "react-router-dom";
import moment from "moment";

export default function LoanSummary({ loanSummary }) {
  const firstDueDate = moment(loanSummary.firstDueDate).format("YYYY-MM-DD");
  const currentDate = moment(new Date()).format("YYYY-MM-DD");

  return (
    <>
      <div className={styles.loanSummary}>
        <div className={styles.header}>
          {/* <Link to="/home" className={styles.backArrow}>
            <IoIosArrowBack size={34} color="#ffffff" />
          </Link> */}
          <p>Repayment</p>
        </div>

        <div className={styles.paymentAmount}>
          <p>Total Re-payment Amount</p>
          <h3>₹{loanSummary.amountToBeRepayed}</h3>
        </div>
      </div>

      <div className={styles.loanDetails}>
        <p className={styles.title}>Loan Summary</p>
        <div className={styles.detailList}>
          <div>
            <p className={styles.label}>Loan Account Number</p>
            <p className={styles.value}>{loanSummary.loanNumber}</p>
          </div>
          <div>
            <p className={styles.label}>Loan Amount(₹)</p>
            <p className={styles.value}>{loanSummary.principal}</p>
          </div>
        </div>

        <div className={styles.detailList}>
          <div>
            <p className={styles.label}>EMI Amount(₹)</p>
            <p className={styles.value}>{loanSummary.Emi}</p>
          </div>
          <div>
            <p className={styles.label}>Loan Tenure</p>
            <p className={styles.value}>{loanSummary.tenure} Months</p>
          </div>
        </div>

        <div className={styles.detailList}>
          <div>
            <p className={styles.label}>Due date</p>
            <p className={`${styles.value} ${styles.dueDate}`}>
              {new Date(loanSummary.firstDueDate).toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}{" "}
              {moment(currentDate).isAfter(firstDueDate) && <span className={styles.due}>Overdue</span>}
            </p>
          </div>
          <div>
            <p className={styles.label}>Last payment date</p>
            {loanSummary.lastPaymentDate && (
              <p className={styles.value}>
                {new Date(loanSummary.lastPaymentDate).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
